// extracted by mini-css-extract-plugin
module.exports = {"socialShareWrapper":"socialShare_socialShareWrapper__r_m5b"};